import moment from 'moment'
import 'moment/locale/pt-br'

moment.locale('pt-br')

/**
 * Returns a short relative timestamp in pt-BR.
 *
 * Examples: "Agora", "10 min atrás", "2 h atrás", "Ontem", "19 mar"
 *
 * Falls back to the original string if parsing fails.
 */
export const formatRelativeTime = (datetime: string): string => {
  const m = moment(datetime, ['DD/MM/YY HH:mm', moment.ISO_8601], true)

  if (!m.isValid()) return datetime

  const now = moment()
  const diffMinutes = now.diff(m, 'minutes')
  const diffHours = now.diff(m, 'hours')
  const diffDays = now.diff(m, 'days')

  if (diffMinutes < 1) return 'Agora'
  if (diffMinutes < 60) return `${diffMinutes} min atrás`
  if (diffHours < 24) return `${diffHours} h atrás`
  if (diffDays === 1) return 'Ontem'

  return m.format('D MMM')
}
